<rcl-header id="checkin-rcl-header" class="no-print" [bg]="brandName" [expandable]="false">
	<!-- inline-svg does not work with string interpolation in the src path -->
	<a id="checkin-rcl-header__link" href="" aria-haspopup="true" (click)="goToBrandUrl($event)">
		<img
			id="checkin-rcl-header__link__header-logo"
			title="home"
			class="{{ brandName }}-header-logo"
			src="assets/icons/{{ brandName }}-logo.svg"
			alt="{{ brandCorpAltText }} Home"
		/>
	</a>

	<rcl-progress-bar [ngClass]="{ 'apply-nav-margin': shouldDisplayMessageCenter }" id="checkin-rcl-header__progress-bar" *ngIf="isProgressBarEnabled">
		<rcl-progress-bar-item
			id="checkin-rcl-header__progress-bar__item-details"
			[disabled]="false"
			[active]="isActiveLink(constants.ROUTES.GUEST_DETAILS)"
		>
			<a id="checkin-rcl-header__progress-bar__item-details__link" [routerLink]="constants.ROUTES.GUEST_DETAILS">
				{{ bundle && bundle['progress.bar.guest'] }}
			</a>
		</rcl-progress-bar-item>

		<rcl-progress-bar-item
			id="checkin-rcl-header__progress-bar__item-oexpenses"
			[disabled]="!isGuestDetailsCompleted || !isTravelQuestionnaireCompleted"
			#oeItem
			[active]="isActiveLink(constants.ROUTES.ONBOARD_EXPENSE)"
		>
			<a
				id="checkin-rcl-header__progress-bar__item-oexpenses__link"
				*ngIf="!oeItem.disabled"
				[routerLink]="constants.ROUTES.ONBOARD_EXPENSE"
			>
				{{ bundle && bundle['progress.bar.onboard.expenses'] }}
			</a>

			<a id="checkin-rcl-header__progress-bar__item-oexpenses__link-disabled" *ngIf="oeItem.disabled">
				{{ bundle && bundle['progress.bar.onboard.expenses'] }}
			</a>
		</rcl-progress-bar-item>

		<rcl-progress-bar-item
			id="checkin-rcl-header__progress-bar__item-cruise-details"
			[disabled]="!isOnboardExpensesCompleted || !isTravelQuestionnaireCompleted"
			#contractsItem
			[active]="isActiveLink(constants.ROUTES.CRUISE_DETAILS)"
		>
			<a
				id="checkin-rcl-header__progress-bar__item-cruise-details__link"
				*ngIf="!contractsItem.disabled"
				[routerLink]="constants.ROUTES.CRUISE_DETAILS"
			>
				{{ bundle && bundle['progress.bar.contracts'] }}
			</a>

			<a id="checkin-rcl-header__progress-bar__item-cruise-details__link-disabled" *ngIf="contractsItem.disabled">
				{{ bundle && bundle['progress.bar.contracts'] }}
			</a>
		</rcl-progress-bar-item>

		<rcl-progress-bar-item
			id="checkin-rcl-header__progress-bar__item-arrival"
			*ngIf="smartship && arrivalTimeEnabled"
			[disabled]="!isCruiseDetailsCompleted || !isTravelQuestionnaireCompleted"
			#arrivalInfoItem
			[active]="isActiveLink(constants.ROUTES.ARRIVAL_INFO)"
		>
			<a
				id="checkin-rcl-header__progress-bar__item-arrival__link"
				*ngIf="!arrivalInfoItem.disabled"
				[routerLink]="constants.ROUTES.ARRIVAL_INFO"
			>
				{{ bundle && bundle['progress.bar.arrival'] }}
			</a>

			<a id="checkin-rcl-header__progress-bar__item-arrival__link-disabled" *ngIf="arrivalInfoItem.disabled">
				{{ bundle && bundle['progress.bar.arrival'] }}
			</a>
		</rcl-progress-bar-item>
	</rcl-progress-bar>

  <rcl-header-extra-option *ngIf="shouldDisplayMessageCenter">
    <main-nav-message-center></main-nav-message-center>
  </rcl-header-extra-option>
	<rcl-menu-button
		id="checkin-rcl-header__menu-button"
		[text]="bundle ? bundle['user.menu.label.my.account'] : ''"
		[expanded]="showMenu"
		(onToggleNav)="showMenu = !showMenu"
	>
	</rcl-menu-button>

	<rcl-menu-button-dropdown id="checkin-rcl-header__menu-button-dropdown" *ngIf="!isSafari">
		<app-user-menu [(showMenu)]="showMenu" [bundle]="bundle"></app-user-menu>
	</rcl-menu-button-dropdown>
</rcl-header>

<app-user-menu id="checkin-user-menu" [(showMenu)]="showMenu" *ngIf="isSafari" [bundle]="bundle"></app-user-menu>

<router-outlet></router-outlet>
